import { render, staticRenderFns } from "./ProjectRestaurantOrder.vue?vue&type=template&id=290fd5fc"
import script from "./ProjectRestaurantOrder.vue?vue&type=script&lang=ts"
export * from "./ProjectRestaurantOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports